<div class="step-content">
  <div class="review-container">
    <div class="review-left">
      <div class="step-header">
        <h2 class="step-title">Paso 7: Revisar & Publicar</h2>
        <p class="step-subtitle">Asegúrate que toda la información esté correcta antes de publicar.</p>
      </div>

      <div class="review-sections">
        <div class="review-section" [class.completed]="isStepCompleted('basicInfo')"
          [class.error]="!isStepCompleted('basicInfo')">
          <div class="section-header">
            <h4 class="section-title">Básicos</h4>
            <span class="status-badge" [class.completed]="isStepCompleted('basicInfo')"
              [class.error]="!isStepCompleted('basicInfo')">
              {{ isStepCompleted('basicInfo') ? 'Completado' : 'Errores pendientes' }}
            </span>
          </div>
          <p class="section-description">
            {{ isStepCompleted('basicInfo')
            ? 'Revisa el nombre, descripción y categoría de tu servicio.'
            : 'Hay campos incompletos o con errores en esta sección.' }}
            <a *ngIf="!isStepCompleted('basicInfo')" (click)="navigateTo.emit(1)">Ir a la sección</a>
          </p>
          <ul class="error-list" *ngIf="getStepErrors('basicInfo').length">
            <li *ngFor="let e of getStepErrors('basicInfo')">{{ e }}</li>
          </ul>
        </div>

        <!-- Tipo & Público -->
        <div class="review-section" [class.completed]="isStepCompleted('typePublic')"
          [class.error]="!isStepCompleted('typePublic')">
          <div class="section-header">
            <h4 class="section-title">Tipo & Público</h4>
            <span class="status-badge" [class.completed]="isStepCompleted('typePublic')"
              [class.error]="!isStepCompleted('typePublic')">
              {{ isStepCompleted('typePublic') ? 'Completado' : 'Errores pendientes' }}
            </span>
          </div>
          <p class="section-description">
            {{ isStepCompleted('typePublic')
            ? 'Tipo & Público configurados.'
            : 'Hay campos incompletos o con errores en esta sección.' }}
            <a *ngIf="!isStepCompleted('typePublic')" (click)="navigateTo.emit(2)">Ir a la sección</a>
          </p>
          <ul class="error-list" *ngIf="getStepErrors('typePublic').length">
            <li *ngFor="let e of getStepErrors('typePublic')">{{ e }}</li>
          </ul>
        </div>

        <!-- Multimedia -->
        <div class="review-section" [class.completed]="isStepCompleted('multimedia')"
          [class.error]="!isStepCompleted('multimedia')">
          <div class="section-header">
            <h4 class="section-title">Multimedia</h4>
            <span class="status-badge" [class.completed]="isStepCompleted('multimedia')"
              [class.error]="!isStepCompleted('multimedia')">
              {{ isStepCompleted('multimedia') ? 'Completado' : 'Errores pendientes' }}
            </span>
          </div>
          <p class="section-description">
            {{ isStepCompleted('multimedia')
            ? 'Imágenes y videos listos.'
            : 'Hay campos incompletos o con errores en esta sección.' }}
            <a *ngIf="!isStepCompleted('multimedia')" (click)="navigateTo.emit(3)">Ir a la sección</a>
          </p>
          <ul class="error-list" *ngIf="getStepErrors('multimedia').length">
            <li *ngFor="let e of getStepErrors('multimedia')">{{ e }}</li>
          </ul>
        </div>

        <!-- Beneficios -->
        <div class="review-section" [class.completed]="isStepCompleted('benefits')"
          [class.error]="!isStepCompleted('benefits')">
          <div class="section-header">
            <h4 class="section-title">Beneficios</h4>
            <span class="status-badge" [class.completed]="isStepCompleted('benefits')"
              [class.error]="!isStepCompleted('benefits')">
              {{ isStepCompleted('benefits') ? 'Completado' : 'Errores pendientes' }}
            </span>
          </div>
          <p class="section-description">
            {{ isStepCompleted('benefits')
            ? 'Beneficios y características definidos.'
            : 'Hay campos incompletos o con errores en esta sección.' }}
            <a *ngIf="!isStepCompleted('benefits')" (click)="navigateTo.emit(4)">Ir a la sección</a>
          </p>
          <ul class="error-list" *ngIf="getStepErrors('benefits').length">
            <li *ngFor="let e of getStepErrors('benefits')">{{ e }}</li>
          </ul>
        </div>

        <!-- Precios/Planes -->
        <div class="review-section" [class.completed]="isStepCompleted('pricing')"
          [class.error]="!isStepCompleted('pricing')">
          <div class="section-header">
            <h4 class="section-title">Precios/Planes</h4>
            <span class="status-badge" [class.completed]="isStepCompleted('pricing')"
              [class.error]="!isStepCompleted('pricing')">
              {{ isStepCompleted('pricing') ? 'Completado' : 'Errores pendientes' }}
            </span>
          </div>
          <p class="section-description">
            {{ isStepCompleted('pricing')
            ? 'Estructura de precios configurada.'
            : 'Hay campos incompletos o con errores en esta sección.' }}
            <a *ngIf="!isStepCompleted('pricing')" (click)="navigateTo.emit(5)">Ir a la sección</a>
          </p>
          <ul class="error-list" *ngIf="getStepErrors('pricing').length">
            <li *ngFor="let e of getStepErrors('pricing')">{{ e }}</li>
          </ul>
        </div>

        <!-- Capacidades -->
        <div class="review-section" [class.completed]="isStepCompleted('capacities')"
          [class.error]="!isStepCompleted('capacities')">
          <div class="section-header">
            <h4 class="section-title">Capacidades</h4>
            <span class="status-badge" [class.completed]="isStepCompleted('capacities')"
              [class.error]="!isStepCompleted('capacities')">
              {{ isStepCompleted('capacities') ? 'Completado' : 'Errores pendientes' }}
            </span>
          </div>
          <p class="section-description">
            {{ isStepCompleted('capacities')
            ? 'Inventario y cupos establecidos.'
            : 'Hay campos incompletos o con errores en esta sección.' }}
            <a *ngIf="!isStepCompleted('capacities')" (click)="navigateTo.emit(6)">Ir a la sección</a>
          </p>
          <ul class="error-list" *ngIf="getStepErrors('capacities').length">
            <li *ngFor="let e of getStepErrors('capacities')">{{ e }}</li>
          </ul>
        </div>
      </div>


      <!-- Confirmación -->
      <div class="confirmation-section">
        <h4 class="confirmation-title">Confirmación Final</h4>
        <label class="confirmation-checkbox">
          <input type="checkbox" [(ngModel)]="confirmationChecked"
            (change)="confirmationEvent.emit(confirmationChecked)">
          <span class="checkmark"></span>
          <span class="confirmation-text">
            Confirmo que he revisado toda la información y es correcta. Entiendo que, una vez publicado, mi
            producto/servicio será visible para todos los usuarios de RedLaboralRD.
          </span>
        </label>
      </div>
    </div>

    <!-- Derecha: Vista previa -->
    <div class="review-right">
      <div class="preview-section">
        <h4 class="preview-title">Vista Previa Final</h4>

        <div class="product-card">
          <!-- Media -->
          <div class="product-card__media">
            @if(coverFileId){
            <img [src]="fileBaseUrl + '/' + coverFileId" alt="Imagen de portada" class="product-card__img" />
            }@else if(coverPreview) {
            <img [src]="coverPreview" alt="Imagen de portada" class="product-card__img" />
            }@else {
            <div class="product-card__placeholder">Imagen de portada</div>
            }
          </div>

          <!-- Body -->
          <div class="product-card__body">
            <h3 class="product-card__title">
              {{ wizardData.basicInfo.title || 'Título pendiente' }}
            </h3>

            <p class="product-card__desc">
              {{ wizardData.basicInfo.shortDescription || 'Descripción corta pendiente.' }}
            </p>

            <!-- Beneficios (usa shortText / iconName del nuevo modelo) -->
            <div class="product-card__benefits" *ngIf="wizardData?.benefits?.length">
              <h5 class="product-card__benefits-title">Beneficios Clave</h5>
              <ul class="product-card__benefits-list">
                <li class="product-card__benefit" *ngFor="let b of wizardData.benefits | slice:0:3">
                  @if (b?.iconName) {
                  <i class="fas" [ngClass]="b.iconName"></i>
                  } @else {
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    aria-hidden="true">
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                  }
                  {{ b.shortText }}
                </li>
              </ul>

              <div class="product-card__more" *ngIf="wizardData.benefits.length > 3">
                +{{ wizardData.benefits.length - 3 }} más
              </div>
            </div>

            <hr class="product-card__divider" />

            <!-- Precio (usa el primer plan o el basePrice si no hay planes) -->
            <div class="product-card__price">
              <h5 class="product-card__price-title">Precio</h5>
              <div class="product-card__price-row">
                <span class="product-card__amount">
                  Desde {{
                  (wizardData.pricing.basePrice)
                  | currency:'USD':'symbol':'1.2-2'
                  }}
                </span>
              </div>
            </div>
          </div>
        </div> <!-- /product-card -->
      </div>
    </div>
  </div>
</div>